function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { StyleSheet, TouchableOpacity } from 'react-native';
import React from 'react';
import { Text, View } from "../../../native";
import Collapsible from "../../../Collapsible";
import * as R from 'unitx/ramda';
import TitleField from "../Fields/TitleField";
import DescriptionField from "../Fields/DescriptionField";
import { useFormContext } from "../FormContext";
import { isAnyOfOrObjectType } from "../../utils";

const FieldTemplate = props => {
  const {
    children,
    displayLabel,
    rawErrors = [],
    rawHelp,
    required,
    rawDescription,
    formContext,
    schema,
    id,
    label
  } = props;
  const {
    formData
  } = children.props.children[0].props;
  const {
    mapping
  } = useFormContext(formContext);
  const isRoot = id === 'root';
  const isComplexType = React.useMemo(() => isAnyOfOrObjectType(schema), [schema]);
  const isRequired = isRoot ? true : required;
  const isNilOrEmpty = R.isNilOrEmpty(formData);
  const [state, setState] = React.useState({
    collapsed: !isRequired && isComplexType
  });

  const deleteIcon = _objectSpread(_objectSpread({}, mapping.deleteIcon), {}, {
    onPress: () => {
      if (!isNilOrEmpty) {
        children.props.children[0].props.onChange(null);
      }

      setState(_objectSpread(_objectSpread({}, state), {}, {
        collapsed: !state.collapsed
      }));
    }
  });

  const onTitlePressCallback = () => {
    // if (!isNilOrEmpty) {
    //   children.props.children[0].props.onChange(null)
    // }
    setState(_objectSpread(_objectSpread({}, state), {}, {
      collapsed: !state.collapsed
    }));
  }; // const collapseIcon = {
  //   ...mapping[state.collapsed ? 'downIcon' : 'upIcon'],
  //   onPress: () => setState({
  //     ...state,
  //     collapsed: !state.collapsed,
  //   }),
  // }


  const icons = R.cond([// [
  //   () => !isRequired && !isNilOrEmpty,
  //   () => ([deleteIcon]),
  // ],
  // [
  //   () => !isRequired && !isNilOrEmpty,
  //   () => ([deleteIcon]),
  // ],
  // [
  //   () => !isRequired && isComplexType,
  //   () => ([deleteIcon]),
  // ],
  // [
  //   () => !isRequired,
  //   () => ([collapseIcon]),
  // ],
  [() => !isNilOrEmpty, () => [deleteIcon]], [R.T, R.always([])]])();
  return /*#__PURE__*/React.createElement(View, _extends({}, mapping.fieldContainer, {
    style: [displayLabel && styles.container, rawErrors.length > 0 && styles.formError, mapping.fieldContainer.style]
  }), !isRoot ? /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: onTitlePressCallback
  }, /*#__PURE__*/React.createElement(TitleField, {
    id: id,
    title: label,
    required: required,
    formContext: formContext,
    icons: icons
  })) : null, displayLabel && rawDescription ?
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(DescriptionField, {
    description: rawDescription,
    formContext: formContext
  }) : null, /*#__PURE__*/React.createElement(Collapsible, {
    collapsed: state.collapsed,
    style: {
      marginLeft: isRoot ? 0 : 10
    }
  }, !state.collapsed && children), rawErrors.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, rawErrors.map((error, i) => /*#__PURE__*/React.createElement(Text, _extends({}, mapping.errorText, {
    style: [mapping.errorText.style, styles.description],
    key: i
  }), "-", ' ', error))), rawHelp && /*#__PURE__*/React.createElement(Text, _extends({}, mapping.description, {
    style: [mapping.description.style, styles.description]
  }), rawHelp));
};

const styles = StyleSheet.create({
  container: {},
  formError: {},
  error: {
    marginTop: 5
  },
  description: {}
});
export default FieldTemplate;